var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("prev"),_c('app-link',{attrs:{"to":_vm.$options.PAGES.TERMS}},[_vm._v(" "+_vm._s(_vm.$t('Terms & Conditions'))+" ")]),_vm._t("middle"),_c('app-link',{attrs:{"to":_vm.$options.PAGES.POLICY}},[_vm._v(" "+_vm._s(_vm.$t('Privacy Policy'))+" ")]),_vm._t("after")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }